// removed by extract-text-webpack-plugin
module.exports = {"cookie-bar":"index__cookie-bar___Gb5bi","cookieBar":"index__cookie-bar___Gb5bi"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/App/index.css
// module id = 768
// module chunks = 12